import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ActionText from '../../../../../../../../components/ActionText'

import { getFormattedOtherParams } from '../../../../helpers'
import { openForm } from '../../../../../../../../modules/actions/forms'

import { UPLOAD_BOOKED_MEDIA_FILES } from '../../../../../../../../constants/forms'

import useStyles from './styles'

const RequestedNameCell = ({ requestedFile, hasMultipleFiles }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { t } = useTranslation()

  const showNumberOfFormats = 3
  // don't show formats if there are multiple files
  const formats = requestedFile?.supported_file_types || []
  const showFormats = hasMultipleFiles ? false : !!formats?.length
  const formatsThatAreShowing = formats.filter((format, index) => index < showNumberOfFormats)
  const hiddenNumberOfFormats = formats?.length > 3 ? formats?.length - showNumberOfFormats : 0

  const openUploadFileForm = useCallback(() => {
    const customDate = requestedFile?.custom_date && requestedFile?.date_start
    dispatch(
      openForm({
        id: requestedFile?.id,
        formName: UPLOAD_BOOKED_MEDIA_FILES,
        otherParams: getFormattedOtherParams({
          mediaId: requestedFile?.booked_media_id,
          customDate
        })
      })
    )
  }, [
    requestedFile?.custom_date,
    requestedFile?.date_start,
    requestedFile?.id,
    requestedFile?.booked_media_id,
    dispatch
  ])

  return (
    <div className={classes.nameField}>
      <div className={classes.nameFieldTexts}>
        <ActionText className={classes.nameMainText} onClick={openUploadFileForm} isDark={true}>
          {requestedFile?.file_name}
        </ActionText>
        {showFormats && (
          <div className={classes.formats}>
            {formatsThatAreShowing?.map(format => (
              <div className={classes.formatField} key={format}>
                .{format}
              </div>
            ))}
            {hiddenNumberOfFormats > 0 && (
              <div className={classes.moreHiddenNumberOfFormats}>{`+ ${hiddenNumberOfFormats} more`}</div>
            )}
          </div>
        )}
        {hasMultipleFiles && <div>{t('Multiple files uploaded')}</div>}
      </div>
    </div>
  )
}

RequestedNameCell.propTypes = {
  requestedFile: PropTypes.object,
  hasMultipleFiles: PropTypes.bool
}

export default RequestedNameCell
